<template>
    <div v-if="visible">
        <el-dialog title="上传应用" :close-on-click-modal="false" 
                v-loading="loading" 
                element-loading-background = "rgba(255, 255,255,0.7)"
                element-loading-text = "上传中..."
                style="width: 100%;margin-bottom: 20px;"
                :visible.sync="visible" :before-close="dialogClose" width="400px">  
                  
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                    <el-upload
                        :action="uploadUrl"
                        ref="upload"
                        class="upload-apply"
                        :show-file-list="true"
                        :auto-upload="false"
                        :on-preview="handlePreview"
                        :on-exceed="handleExceed"
                        :on-remove="handleRemove"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload">
                        <el-button slot="trigger" size="small" type="primary">选择上传全量/补丁应用</el-button>
                    </el-upload>

                    <el-form-item prop="applyType" label="应用类型">
                        <el-radio-group v-model="form.applyType">
                            <el-radio :label="1">全量</el-radio>
                            <el-radio :label="2">补丁</el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item prop="applyVersion" label="应用版本">
                        <el-input v-model="form.applyVersion" maxlength="10" placeholder="版本格式：1.0.1,1.0.2..."></el-input>
                    </el-form-item> 
 
                    <el-form-item   prop="remark" label="版权说明">
                        <el-input
                            type="textarea"
                            placeholder=""
                            v-model="form.remark"
                            maxlength="200"
                            show-word-limit>
                        </el-input>
                    </el-form-item> 

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">上 传</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../common/http';

    export default {
        data(){
            return{
                visible: false,
                loading:false,
                form:{
                    applyType: 1,
                    applyVersion:"",
                    remark:""
                },
                fileList:[],
                uploadUrl:"",
                rules: {
                    applyVersion: [
                        { required: true, message: '请输入应用版本', trigger: 'blur' }
                    ]
                },

            }
        },
        created:function () {
        },
        methods:{
            init(deptId){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                // 初始数据
                this.form.applyType=1;
                this.form.applyVersion="";
                this.form.remark="";
                this.uploadUrl=this.applyManageUploadAndroidUrl;
                this.fileList=[];
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            mounted:function () {
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){

                        if(this.$refs.upload.uploadFiles.length == 0){
                            this.$commonFn.showTip('应用为空，请上传', 3);
                            return;
                        }
                        
                        // 上传文件
                        this.loading=true;

                        this.fileList=[];
                        this.$refs.upload.submit();

                        // 延迟1秒执行
                        setTimeout(this.uploadFile, 1000)
                    }
               });
            },
            handleAvatarSuccess(res, file) {
                
            },
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择2个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            beforeAvatarUpload(file) {
                let fileType = file.type;
                let isLt2M = file.size / 1024 / 1024 < 200;
                console.log("文件大小："+file.size);
                if (!isLt2M) {
                    this.$commonFn.showTip('文件大小不能超过200MB!', 3);
                    this.$refs.upload.clearFiles(); // 清除文件
                    return false;
                }
                // .exe是全量文件，.asar是补丁文件
                let fileName=file.name;
                //获取最后一个.的位置
                let index= fileName.lastIndexOf(".");
                //获取后缀
                let ext = fileName.substr(index+1);
                let fileObj={};
                fileObj.key=ext;
                fileObj.val=file;
                this.fileList.push(fileObj);
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log(file);
            },
            uploadFile(){ // 上传文件
                console.log("上传文件", this.fileList);
                // 验证全量应用，补丁是否都有
                let isExe=false;
                let isAsar=false;
                let file=[];
                for(let i = 0; i < this.fileList.length; i++) {
                    let obj = this.fileList[i];
                    if('apk' == obj.key){ // 全量包
                        isExe=true;
                        file.push(obj.val);
                    }
                    if('wgt' == obj.key){ // 补丁包
                        isAsar=true;
                        file.push(obj.val);
                    }
                }

                if(!isExe && this.form.applyType == 1){
                    this.$commonFn.showTip("全量应用格式不对，请上传apk", 3);
                    this.loading=false;
                    this.$refs.upload.clearFiles(); // 清除文件
                    return;
                }

                if(!isAsar && this.form.applyType == 2){
                    this.$commonFn.showTip("补丁应用格式不对，请上传wgt", 3);
                    this.loading=false;
                    this.$refs.upload.clearFiles(); // 清除文件
                    return;
                }

                let uploadForm=new FormData();
                for(let i=0;i<file.length;i++){
                    uploadForm.append('file', file[i]);
                }
                uploadForm.append('applyType', this.form.applyType);
                uploadForm.append('applyVersion', this.form.applyVersion);
                uploadForm.append('remark', this.form.remark);

                console.log('上传文件...',uploadForm);
                // return;

                this.$axios.post(this.uploadUrl, uploadForm,{
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then((res) => {
                    console.log("文件反馈:"+JSON.stringify(res.data))
                    if(res.data.status == 200){
                        this.$commonFn.showTip(res.data.message,1);
                        this.$parent.getData();
                        this.visible=false;
                    }else{
                        this.fileList=[];
                        this.$commonFn.showTip(res.data.message,3);
                    }
                    this.loading=false;
                }, (err) => {
                    console.log(err)
                    this.$commonFn.showTip("网络繁忙，请稍后重试，响应码("+err.response+")", 3);
                    this.$refs.upload.clearFiles(); // 清除文件
                    this.loading=false;
                });

            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    
</style>


// WEBPACK FOOTER //
// src/components/page/apply/AddAndroid.vue